import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { pageViewTracked } from "~redux/features/stories-slice";
import { selectCurrentSlug } from "~redux/features/transporter-slice";
import { Story } from "~types/types";
import refreshAbba from "~utils/refreshAbbaClient";
import {
    parselyTrackPageView,
    recordPageView,
    updateUrlTitle,
} from "~utils/syncOnStory";

type UseUpdateStoryInViewportMetadataProps = {
    story: Story;
    inViewport: boolean;
    isFirstStoryOnPage: boolean;
};

function useUpdateStoryInViewportMetadata({
    story,
    isFirstStoryOnPage,
}: UseUpdateStoryInViewportMetadataProps) {
    const dispatch = useDispatch();

    const currentSlug = useSelector(selectCurrentSlug);

    useEffect(() => {
        if (!isFirstStoryOnPage) return;

        updateUrlTitle(story, false);
        parselyTrackPageView(story.url);
    }, []);

    useEffect(() => {
        if (currentSlug !== story.slug) return;

        updateUrlTitle(story, !isFirstStoryOnPage);
        refreshAbba(story);

        if (!story.isPageTracked) {
            recordPageView(story, true);
            dispatch(pageViewTracked(story));
        }
    }, [currentSlug]);
}

export default useUpdateStoryInViewportMetadata;
